// extracted by mini-css-extract-plugin
module.exports = {"root":"StrategyGoals_root__1jxHR","goal":"StrategyGoals_goal__1tHAX","goalTitle":"StrategyGoals_goalTitle__29agy","goalRanking":"StrategyGoals_goalRanking__3togY"};